module.exports = __webpack_public_path__ + "img/vegetable-broccoli-350x184.9b4b78c2.jpg";